var uiCursorPagination = {
	caption: "Curseur de pagination",
	first: "Première page",
	previous: "Page précédente",
	next: "Page suivante"
};
var fr = {
	uiCursorPagination: uiCursorPagination
};

export { fr as default, uiCursorPagination };
